// this should match feature_flags concern
export type FeatureFlags = {
  //some_feature_flag: boolean
}

let cached: FeatureFlags | null = null

export function readBootFlags(): FeatureFlags {
  if (cached) return cached
  const el = document.getElementById('boot-flags')
  if (!el) return (cached = {} as FeatureFlags)
  try {
    cached = JSON.parse(el.textContent || '{}') as FeatureFlags
  } catch {
    cached = {} as FeatureFlags
  }
  return cached
}
